// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2U4VQ","withError":"styles_withError__nY45I","withOutError":"styles_withOutError__io_k4","content":"styles_content__1tNQ0"};